/* Instachiq fast cart drawer: instant remove / quantity change (cart-fx) */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var css = '.cfx-bar{position:absolute;top:0;left:0;right:0;height:3px;z-index:5;overflow:hidden;pointer-events:none;opacity:0;transition:opacity .2s}' +
    '.cfx-bar:after{content:"";position:absolute;top:0;bottom:0;width:40%;background:linear-gradient(90deg,transparent,#e3b94a,#f0d27a,transparent);animation:cfxSlide 1s linear infinite}' +
    '.cfx-busy .cfx-bar{opacity:1}.cfx-busy [data-cart-subtotal-price]{opacity:.55;transition:opacity .2s}' +
    '@keyframes cfxSlide{from{left:-40%}to{left:100%}}' +
    '.cfx-leaving{pointer-events:none;overflow:hidden}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var renderedCart = null, pending = 0, chain = Promise.resolve(), timers = {};
  function dr() { return document.querySelector('m-cart-drawer'); }
  function items() { return dr() && dr().querySelector('m-cart-drawer-items'); }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function domCount() { var it = items(); return it ? it.querySelectorAll('[data-cart-item]').length : -1; }
  function ensureCart() {
    var stale = !renderedCart || (pending === 0 && domCount() !== renderedCart.items.length);
    return stale ? getCart().then(function (c) { renderedCart = c; optimistic = null; return c; }) : Promise.resolve(renderedCart);
  }
  function money(c) {
    try { if (typeof window.formatMoney === 'function') return formatMoney(c, MinimogSettings.money_format); } catch (e) {}
    return (c / 100).toFixed(2);
  }
  function setCount(n) {
    document.querySelectorAll('.m-cart-count-bubble').forEach(function (b) {
      if (n > 0) { b.textContent = n; b.classList.remove('m:hidden'); } else b.classList.add('m:hidden');
    });
  }
  function setSubtotal(c) {
    var el = document.querySelector('m-cart-drawer [data-cart-subtotal-price]');
    if (el && c >= 0) el.textContent = money(c);
  }
  function busy(on) {
    var d = dr(); if (!d) return;
    var inner = d.querySelector('.m-cart-drawer__inner');
    if (inner && !inner.querySelector('.cfx-bar')) { var b = document.createElement('div'); b.className = 'cfx-bar'; inner.appendChild(b); }
    d.classList.toggle('cfx-busy', !!on);
  }
  /* optimistic totals kept locally between server confirmations */
  var optimistic = null;
  function opt() { if (!optimistic && renderedCart) optimistic = { total: renderedCart.total_price, count: renderedCart.item_count }; return optimistic; }

  function render() {
    return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var d = dr(); if (!d || !s || !s['cart-drawer']) return;
        d.getSectionsToRender().forEach(function (x) {
          var t = x.selector ? document.querySelector(x.selector) : document.getElementById(x.id);
          if (t) t.innerHTML = d.getSectionInnerHTML(s['cart-drawer'], x.selector);
        });
        if (window.FoxKitV2 && FoxKitV2.Modules && FoxKitV2.Modules.InCart) try { FoxKitV2.Modules.InCart.getCart(); } catch (e) {}
      });
  }
  function toast(msg) {
    try { MinimogTheme.Notification.show({ target: items() || document.body, method: 'prepend', type: 'warning', message: msg }); } catch (e) {}
  }

  function send(key, qty) {
    pending++; busy(true);
    chain = chain.then(function () {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, data: j }; }); });
    }).then(function (res) {
      if (!res.ok) toast(res.data.description || res.data.message || (window.MinimogStrings && MinimogStrings.cartError) || 'Error');
      else lastCart = res.data;
    }).catch(function () {}).then(function () {
      pending--;
      if (pending > 0) return;
      /* queue drained: sync the drawer with the server once */
      return render().then(getCart).then(function (c) {
        renderedCart = c; optimistic = null;
        setCount(c.item_count);
        var d = dr(); if (d) d.classList.toggle('m-cart--empty', c.item_count === 0);
        var it = items(); if (it) it.classList.toggle('m-cart--empty', c.item_count === 0);
        try { MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, Object.assign({}, c, { source: 'main-cart-items' })); } catch (e) {}
      }).catch(function () { renderedCart = null; }).then(function () { if (pending === 0) busy(false); });
    });
  }
  var lastCart = null;

  function lineFor(index) { return renderedCart && renderedCart.items[index - 1]; }

  function animateOut(el) {
    if (!el) return Promise.resolve();
    if (reduce) { el.remove(); return Promise.resolve(); }
    var h = el.offsetHeight, dir = document.documentElement.dir === 'rtl' ? 1 : -1;
    el.classList.add('cfx-leaving');
    return el.animate([
      { transform: 'translateX(0)', opacity: 1 },
      { transform: 'translateX(' + 60 * dir + 'px)', opacity: 0 }
    ], { duration: 220, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' }).finished.then(function () {
      return el.animate([
        { height: h + 'px', paddingTop: getComputedStyle(el).paddingTop, paddingBottom: getComputedStyle(el).paddingBottom, marginBottom: getComputedStyle(el).marginBottom },
        { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginBottom: '0px' }
      ], { duration: 220, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' }).finished;
    }).then(function () { el.remove(); });
  }

  /* ---- remove: slide out instantly, network in background ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('m-cart-drawer m-cart-remove-button');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var index = parseInt(btn.dataset.index, 10);
    var row = btn.closest('[data-cart-item]');
    if (!row || row.classList.contains('cfx-leaving')) return;
    var applyTotals = function () {
      var line = lineFor(index), o = opt();
      if (line && o) { var q = line.__q != null ? line.__q : line.quantity; o.total -= q * line.final_price; o.count -= q; line.__q = 0; setSubtotal(o.total); setCount(o.count); }
      return line;
    };
    var ready = renderedCart && !(pending === 0 && domCount() !== renderedCart.items.length);
    if (ready) applyTotals();
    busy(true);
    animateOut(row).then(function () {
      var left = items() && items().querySelectorAll('[data-cart-item]:not(.cfx-leaving)').length;
      if (left === 0) { var d = dr(); if (d) d.classList.add('m-cart--empty'); }
    });
    (ready ? Promise.resolve() : ensureCart().then(applyTotals)).then(function () {
      var line = lineFor(index);
      if (!line) { window.location.reload(); return; }
      send(line.key, 0);
    });
  }, true);

  /* ---- quantity +/- or typed: totals update instantly, network debounced ---- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'updates[]' || !input.closest('m-cart-drawer m-cart-drawer-items')) return;
    if (input.disabled) return;
    e.stopPropagation(); e.stopImmediatePropagation();
    var index = parseInt(input.dataset.index, 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    var apply = function () {
      var line = lineFor(index); if (!line) return null;
      var o = opt(), prev = line.__q != null ? line.__q : line.quantity;
      if (qty !== prev && o) { o.total += (qty - prev) * line.final_price; o.count += qty - prev; setSubtotal(o.total); setCount(o.count); }
      line.__q = qty;
      return line;
    };
    var ready = renderedCart && !(pending === 0 && domCount() !== renderedCart.items.length);
    if (ready) apply();
    if (qty === 0) animateOut(input.closest('[data-cart-item]'));
    busy(true);
    clearTimeout(timers[index]);
    timers[index] = setTimeout(function () {
      (ready ? Promise.resolve() : ensureCart().then(apply)).then(function () {
        var line = lineFor(index);
        if (!line) { window.location.reload(); return; }
        send(line.key, qty);
      });
    }, 300);
  }, true);

  /* keep a fresh copy of the cart ready whenever the drawer opens */
  function prefetch() { if (pending === 0) ensureCart().catch(function () {}); }
  var d1 = dr();
  if (d1) new MutationObserver(function () { if (d1.classList.contains('m-cart-drawer--active')) prefetch(); }).observe(d1, { attributes: true, attributeFilter: ['class'] });
  if (window.requestIdleCallback) requestIdleCallback(prefetch, { timeout: 4000 }); else setTimeout(prefetch, 2500);

  /* the drawer content was replaced by another script (e.g. add to cart): forget the cached cart */
  window.addEventListener('submit', function (e) {
    var a = e.target && e.target.getAttribute && (e.target.getAttribute('action') || '');
    if (/\/cart\/add/.test(a)) { renderedCart = null; optimistic = null; }
  }, true);
})();
